// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1LOFQ","item":"PaymentsMobile_item__2RvwS","label":"PaymentsMobile_label__1pGtZ","amount":"PaymentsMobile_amount__bmjFy"};